import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dark-bottom-svg',
  templateUrl: './dark-bottom-svg.component.html',
  styleUrls: ['./dark-bottom-svg.component.scss']
})
export class DarkBottomSvgComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
